require('normalize.css/normalize.css');
require('bootstrap/dist/css/bootstrap.min.css');
require('styles/App.less');

const axios = require('axios');

import React from 'react';
import intl from 'react-intl-universal';
import http from 'axios';
import Header from './Header';
import Footer from './Footer';
import Spinner from './Spinner';
import AuthStore from '../stores/AuthStore';
import { withRouter } from 'react-router-dom';

const locales = [
  { name: 'English', value: 'en-US' },
  { name: 'Polski', value: 'pl-PL' }
];

class AppComponent extends React.Component {
  constructor(){
    super();
    this.state = {
      authenticated: AuthStore.isAuthenticated(),
      initDone: false
    }
  }

  componentWillMount() {
    const conf = window.ODOO
    if(window.confMode === true){
      setTimeout(() => {document.querySelector('.loaderWrap').style.display = 'none'}, 1000)
      return
    }
    if(document.querySelector('.logoStyle') === null){
      let logo = document.createElement('style')
      logo.classList.add('logoStyle');
      logo.innerHTML +=`
        #app header .logo{
          background-image: url(${conf.url + (conf.port?':'+conf.port:'')}/web/binary/company_logo)
        }
        `
      document.getElementsByTagName('head')[0].appendChild(logo);
    }
    if(document.querySelector('.brandStyle') === null){
      let brandUrl = conf.url + (conf.port?':'+conf.port:'')+'/brand/'
      axios.get(brandUrl).then(function (response) {
        if(response.status == 200){
          let brandData = response.data
          let style = document.createElement('style')
          style.classList.add('brandStyle');
          if (brandData && brandData.colors && brandData.colors['@brand-primary'] && brandData.colors['@brand-primary-text']){
            style.innerHTML = `
              #app thead tr,
              #app main h4,
              #app main button, #popupContainer .mm-popup button,
              #app main .button, #popupContainer .mm-popup .button,
              #app main input[type="submit"],
              #app main .pakowanie .checkbox.checked,
              #app main div.done h3,
              #app footer,
              #app footer a, #app footer a:hover, #app footer a:visited
              {
                background-color: ${brandData.colors['@brand-primary']};
                color: ${brandData.colors['@brand-primary-text']};
              }
              #app main .elem-list .elem-tile:hover{
                border-color: ${brandData.colors['@brand-primary']};
              }
              #app main .pakowanie .checkbox .checkbox-inner:before,
              #app main .pakowanie .checkbox .checkbox-inner:after{
                background-color: ${brandData.colors['@brand-primary-text']};
              }
              `
          }
          document.getElementsByTagName('head')[0].appendChild(style);
        }
      }).finally(function () {
        //no brand data - do nothing
        if(document.querySelector('.loaderWrap'))
          document.querySelector('.loaderWrap').style.display = 'none'
      })
    }
  }

  loadLocales() {
    let currentLocale = intl.determineLocale({
      urlLocaleKey: 'lang',
      cookieLocaleKey: 'lang'
    });
    if (!locales.find((l)=>{return l.value == currentLocale })) {
      currentLocale = 'pl-PL';
    }

    http.get(`translations/${currentLocale}.json`).then(res => {
      // init method will load CLDR locale data according to currentLocale
      return intl.init({
        currentLocale,
        locales: { [currentLocale]: res.data }
      });
    }).then(() => {
      // After loading CLDR locale data, start to render
      this.setState({ initDone: true });
      document.querySelector('.loaderWrap').style.display = 'none'
    });
  }

  render() {
    return (
      this.state.initDone &&
        <article>
          <Spinner/>
          <Header authenticated={this.props.authenticated}></Header>
          <main>
          {this.props.children}
          </main>
          <Footer locales={locales}/>
        </article>
    );
  }

  componentDidMount(){
    this.loadLocales();
  }
}

AppComponent.defaultProps = {
};

export default withRouter(AppComponent);



// WEBPACK FOOTER //
// ./src/components/App.js